import { render, staticRenderFns } from "./SearchIssue.vue?vue&type=template&id=a3f5ff78&"
import script from "./SearchIssue.vue?vue&type=script&lang=js&"
export * from "./SearchIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports